import { GHLLanguageKeys as a } from "./ghl-ui.es243.js";
import r from "./ghl-ui.es1127.js";
const f = {
  name: a.frenchCanada,
  locale: r
};
export {
  f as date_fr_CA
};
